import { CityStateLookupError } from "./city-state-lookup-error";

export class ZipCodeInfo {
  Error: CityStateLookupError;
  Zip5: string;
  City: string;
  State: string;
}
